import { useState, Fragment, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { IRootState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../../api/api';
import { toast } from 'react-toastify';
import Loader from '../../../component/layout/Loader';
import { t } from 'i18next';
import { Dialog, Transition } from '@headlessui/react';
import IconX from '../../../component/icon/IconX';
import CameraComponent from '../../../component/CameraComponent';
import { addCapturedImage, setCapturedImages } from '../../../store/slice/AttendanceSlice';
import { removeCapturedImage } from '../../../store/slice/AttendanceSlice';
import IconDownload from '../../../component/icon/IconDownload';


const PAGE_SIZES = [10, 20, 30, 50, 100]
const AttendanceView = () => {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const params = useParams()

    const [courseData, setCourseData] = useState<any>({})
    
    const [description, setDescription] = useState("")
    const [selectedCoaches, setSelectedCoaches] = useState<any>([])
    const [selectedStudents, setSelectedStudents] = useState<any>([])
    const [showCamera, setShowCamera] = useState(false)
    const dispatch = useDispatch()
    const { selectedAttendance } = useSelector((state: IRootState) => state.attendance)
    const capturedImages = useSelector((state: IRootState) => state.attendance.capturedImages)
    const [previewImage, setPreviewImage] = useState<string | null>(null)

    const handleCheckboxChange = (selectedId:number, type: string) => {
        if (type=="coach") {
            setSelectedCoaches((prev:any) => prev.includes(selectedId) ? prev.filter((coachId:any) => coachId !== selectedId) : [...prev, selectedId] )
        } else if (type=="student") {
            setSelectedStudents((prev:any) => prev.includes(selectedId) ? prev.filter((coachId:any) => coachId !== selectedId) : [...prev, selectedId] )
        }
    }

    useEffect(() => {
        if (!selectedAttendance.branch_name) {
            navigate('/schedule')
            return
        }
    }, [selectedAttendance, navigate])

    useEffect(() => {
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/coach/class?class_code=${params.class_code}&course_date=${params.date}`).then(res => {
            setLoading(false)
            console.log("res", res)
            // setSelectedStudents(res.data.data.students_attended_ids)
            // setSelectedCoaches(res.data.data.coaches_attended_ids)
            setCourseData(res.data.data)

            // default make all student attendace taken
            setSelectedStudents(res.data.data.students.map((student:any) => student.id))
        }).catch(err => {
            setLoading(false)
            console.log("err", err)
            if (err.response.status === 500) {
                toast.error(t("attendance.invalid_attendance"))
                return navigate('/schedule')
            }
        })
    }, [])

    useEffect(() => {
        if (courseData) {
            setDescription(courseData.description || "")
            // Validate student IDs, if student_attended_ids ids does not exist in students, then dont include
            let validStudentIds = (courseData.students_attended_ids || []).filter((id: number) =>
                (courseData.students || []).some((student: any) => student.id === id)
            )
            if (validStudentIds.length === 0) {
                if (courseData.attendance_image && courseData.attendance_image.length !== 0) {
                    // Attendance taken, but no students were present
                    validStudentIds = []
                } else if (courseData.students) {
                    // No attendance taken yet, default to all students
                    validStudentIds = courseData.students.map((student: any) => student.id)
                }
            }

            // Validate coach IDs
            const validCoachIds = (courseData.coaches_attended_ids || []).filter((id: number) =>
                (courseData.coaches || []).some((coach: any) => coach.id === id)
            )

            setSelectedStudents(validStudentIds)
            setSelectedCoaches(validCoachIds)
            if (courseData.attendance_image && courseData.attendance_image.length > 0) {
                dispatch(setCapturedImages(courseData.attendance_image))
            } else {
                dispatch(setCapturedImages([]))
            }
        }
    }, [courseData])

    function handleSubmitAttendance() {
        // validate attendance image
        if (capturedImages.length === 0) return toast.error("At least 1 image is required")
        if (capturedImages.length > 10) return toast.error("You can only submit up to 10 images")
        if (description==="") return toast.error("Description required")
        if (selectedCoaches.length === 0) return toast.error("Coaches required")

        let payload = {
            // "course_slot_id": params.course_slot_id,
            // "course_schedule_id": params.course_schedule_id,
            // "time_slot_id": params.time_slot_id,
            "class_code": params.class_code,
            "course_date": params.date,
            images: capturedImages,
            "description": description,
            "students": selectedStudents,
            "coaches": selectedCoaches
        }
        // console.log("payload", payload)
        
        setLoading(true)
        api.post(`${process.env.REACT_APP_API_BASE_URL}/attendance/add`, payload).then(res => {
            setLoading(false)
            console.log("res", res)
            if (res.status == 200) {
                toast.success(t("attendance.attendance_taken"))
                return navigate('/schedule')
            }
            toast.error(t("server_error"))
        }).catch(err => {
            setLoading(false)
            console.log("err", err)
            if (err.response && err.response.data && err.response.data.errors) {
                const errors = err.response.data.errors
                Object.keys(errors).forEach(key => {
                    errors[key].forEach((message:string) => {
                        toast.error(`${key} : ${message}`)
                    })
                })
            } else {
                toast.error(t("server_error"))
            }
        })
    }
    

    return (
        <div>
            {loading && <Loader/>}
            {/* <div className="flex items-center justify-between flex-wrap gap-4">
                <h2 className="text-xl">{(courseData.course && courseData.course.name) || "-"} ({courseData.students && courseData.students.length})</h2>
            </div> */}

            <div className='grid grid-cols-2 my-3 mb-5 gap-2'>
                <div>
                    <div className='mb-2'><b>{t('date')}</b>: {params.date}</div>
                    <div className='break-words whitespace-normal'><b>{t('classroom')}</b>: {courseData.class_name}</div>
                </div>
                <div>
                    <div className='mb-2'><b>{t('time')}</b>: {courseData.time}</div>
                    <div><b>{t('branch_name')}</b>: {selectedAttendance.branch_name}</div>
                </div>
            </div>
            
           {capturedImages.length > 0 ? (
                <div className="my-5 grid grid-cols-2 sm:grid-cols-6 gap-4">
                    {capturedImages.map((img, index) => (
                    <div key={index} className="relative">
                        <img src={img} alt={`Captured ${index + 1}`} className="rounded-md max-h-40 w-full object-cover" />
                        <button onClick={() => dispatch(removeCapturedImage(index))} className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded-full text-xs" >✕</button>
                        <button
                            onClick={async () => { setPreviewImage(img) }}
                            className="absolute bottom-1 right-1 bg-white text-gray-700 p-1 rounded-full shadow text-xs hover:bg-gray-100"
                            title="Download Image"
                            >
                            <IconDownload className="w-4 h-4" />
                        </button>
                    </div>
                    ))}
                </div>
                ) : (
                <div className="my-5 text-center">
                    <img src="/assets/images/no-image-placeholder.jpg" alt="No" className="rounded-md max-h-72 mx-auto" />
                </div>
                )}

                {capturedImages.length < 10 && (
                    <div>
                        <button
                            type="button"
                            onClick={() => setShowCamera(true)}
                            className="justify-self-center btn btn-primary rounded-3xl !mt-6 w-full sm:w-1/2 md:w-2/6"
                        >
                            {capturedImages.length === 0 ? t("attendance.take_image") : t("attendance.add_more_image")}
                        </button>
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            style={{ display: 'none' }}
                            id="gallery-upload"
                            onChange={async (e) => {
                                const files = Array.from(e.target.files || []);
                                if (files.length === 0) return;
                                if (capturedImages.length + files.length > 10) {
                                    toast.error(t("attendance.max_image_limit"));
                                    return;
                                }
                                for (const file of files) {
                                    const reader = new FileReader();
                                    reader.onload = (ev) => {
                                        if (ev.target?.result) {
                                            dispatch(addCapturedImage(ev.target.result as string));
                                        }
                                    };
                                    reader.readAsDataURL(file);
                                }
                                // Reset input value so same file can be selected again
                                e.target.value = '';
                            }}
                        />
                        <button
                            type="button"
                            onClick={() => document.getElementById('gallery-upload')?.click()}
                            className="justify-self-center btn btn-secondary rounded-3xl !mt-2 w-full sm:w-1/2 md:w-2/6"
                        >
                            {t("attendance.upload_from_gallery")}
                        </button>
                    </div>
                )}
            <div className="my-5 mb-8">
                <label htmlFor="address">{t("attendance.description")}</label>
                <textarea rows={3} value={description} onChange={(e)=>{setDescription(e.target.value)}} placeholder={t("attendance.enter_description")} className="form-textarea resize-none min-h-[130px]" ></textarea>
            </div>


            <div className='text-lg'>{t("attendance.coaches")}</div>
            <div className="mt-5 panel p-0 border-0 overflow-hidden mb-8">
                <div className="table-responsive">
                    <table className="table-striped table-hover">
                        <thead>
                            <tr>
                                <th>{t('name')}</th>
                                <th>{t('attendance.attended')}</th>
                            </tr>
                        </thead>
                        <tbody>
                        {courseData.coaches && courseData.coaches.map((item:any, index:number) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <div>{item.name}</div>
                                    </td>
                                    <td>
                                        <div>
                                            <label className="inline-flex cursor-pointer">
                                                <input type="checkbox" checked={selectedCoaches.includes(item.id)} onChange={()=>{handleCheckboxChange(item.id, "coach")}} className="form-checkbox" />
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='text-lg'>{t("courses")}</div>
            <div className="mt-5 panel p-0 border-0 overflow-hidden mb-8">
                <div className="table-responsive">
                    <table className="table-striped table-hover">
                        <thead>
                            <tr>
                                <th>{t('name')}</th>
                            </tr>
                        </thead>
                        <tbody>
                        {courseData.course && courseData.course.map((item:any, index:number) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <div>{item.name}</div>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>


            <div className='text-lg mt-5'>{t('attendance.students')}</div>
            <div className="mt-5 panel p-0 border-0 overflow-hidden">
                <div className="table-responsive">
                    <table className="table-striped table-hover">
                        <thead>
                            <tr>
                                <th>{t('name')}</th>
                                <th>{t('attendance.attended')}</th>
                            </tr>
                        </thead>
                        <tbody>
                        {courseData.students && courseData.students.map((item:any, index:number) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <div className="flex items-center gap-2">
                                            <span>{item.name}</span>
                                            {item.status === "replacement" && (
                                                <div className="relative group">
                                                    <svg className="w-4 h-4 text-blue-600 cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                                    </svg>
                                                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-xs rounded py-1 px-2 whitespace-nowrap">
                                                        {t('attendance.replacement_student')}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <label className="inline-flex cursor-pointer">
                                                <input type="checkbox" checked={selectedStudents.includes(item.id)} onChange={()=>{handleCheckboxChange(item.id, "student")}} className="form-checkbox" />
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>

            
            <div className="grid grid-cols-4 mt-10">
                <div className="col-span-2 mb-5 justify-self-start" onClick={()=>{navigate("/schedule")}}>
                    <button type="button" className="btn btn-secondary">{t('back')}</button>
                </div>
                <div className="col-span-2 mb-5 justify-self-end" onClick={()=>{ handleSubmitAttendance() }}>
                    <button type="button" className="btn btn-primary">{t('submit')}</button>
                </div>
            </div>


            <Transition appear show={showCamera} as={Fragment} static >
                <Dialog as="div" open={showCamera} onClose={() => {
                    setShowCamera(false)
                    // setCameraFrontOrBack("environment") // reset back camera orientation
                }} className="relative z-[51]">
                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center px-4 py-8 md:px-16 md:py-16">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="panel border-0 p-0 rounded-lg overflow-hidden w-full max-w-5xl text-black dark:text-white-dark">
                                    <div className="flex justify-between px-6 pt-4">
                                        <button type="button" onClick={() => {
                                            setShowCamera(false)
                                        }} className="col-span-2 ltr:right-4 rtl:left-4 text-gray-400 hover:text-gray-800 dark:hover:text-gray-600 outline-none" >
                                            <IconX />
                                        </button>
                                    </div>
                                    <div className="mt-4">
                                        <CameraComponent
                                            onCapture={(imageSrc) => {
                                                dispatch(addCapturedImage(imageSrc))
                                                setShowCamera(false)
                                            }}
                                        />
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            {previewImage && (
                <div className="fixed inset-0 bg-black bg-opacity-100 flex items-center justify-center z-[1100]" onClick={() => setPreviewImage(null)} >
                    <div className="relative max-w-full max-h-full p-4" onClick={(e) => e.stopPropagation()} >

                        {/* Close button */}
                        <button onClick={() => setPreviewImage(null)} className="absolute top-2 left-2 bg-white text-black rounded-full p-1.5 shadow-md hover:bg-gray-100" aria-label="Close" >
                            <IconX/>
                        </button>

                        <img src={previewImage} alt="Preview" className="max-h-[90vh] max-w-[90vw] object-contain rounded-md" />

                        <button
                            onClick={async () => {
                                try {
                                    const response = await fetch(previewImage, { mode: 'cors' });
                                    const blob = await response.blob();
                                    const blobUrl = window.URL.createObjectURL(blob);

                                    const link = document.createElement('a');
                                    link.href = blobUrl;
                                    link.download = 'attendance-image.jpg';
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);

                                    window.URL.revokeObjectURL(blobUrl);
                                } catch (err) {
                                    toast.error("Download image failed");
                                }
                        }}
                        className="absolute -bottom-10 right-4 bg-primary text-white px-3 py-1.5 text-sm rounded-full shadow-lg"
                        >
                        {t("attendance.download_image")}
                        </button>
                    </div>
                    </div>
                )}

        </div>

    )
}

export default AttendanceView